<script>
  import SmallTitle from '../../common/SmallTitle.svelte';
  import RosterPlayers from './RosterPlayers.svelte';
  import RosterCoaches from './RosterCoaches.svelte';

  export let value;
  export let lang = undefined;
  export let mode = undefined;

  const i18n = {
    players: {
      cs: 'Hráči',
      en: 'Players',
    },
    coaches: {
      cs: 'Trenéři',
      en: 'Coaches',
    },
    notAvailable: {
      cs: 'Soupiska není k dispozici.',
      en: 'Roster is not available.',
    },
  };
</script>

{#if value.players.length > 0 || value.coaches.length > 0}
  <div class='roster'>
    {#if value.players.length > 0}
      <div class='roster-players'>
        <SmallTitle value={i18n.players[lang]}/>

        <RosterPlayers value={value.players} bind:lang bind:mode/>
      </div>
    {/if}

    {#if value.coaches.length > 0}
      <div class='roster-coaches'>
        <SmallTitle value={i18n.coaches[lang]}/>

        <RosterCoaches value={value.coaches} bind:lang bind:mode/>
      </div>
    {/if}
  </div>
{:else}
  <div class='roster-not-available'>
    {i18n.notAvailable[lang]}
  </div>
{/if}

<style>
  .roster {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .roster-players {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .roster-coaches {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .roster-not-available {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 100%;
    height: 100%;
    min-height: 22.5px;

    text-align: center;
    text-transform: uppercase;

    letter-spacing: 1.2px;
  }
</style>
